import SelectorEntriesPresentationList from 'components/SelectorEntries/SelectorEntriesPresentationList'
import SelectorEntriesContainer from 'components/SelectorEntries/SelectorEntriesContainer'

export default {
  Container: SelectorEntriesContainer,
  Presentation: SelectorEntriesPresentationList,
}
